import * as React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'react-multi-carousel/lib/styles.css';
import {
    Box,
    Card,
    CardMedia,
    Container,
    Typography,
  } from "@mui/material";
import { fontBrand } from '../../../getLPTheme';
import { useEffect, useRef } from "react";


export default function BannerCarousel () {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.7;
    }
  }, []);

  return (
    <Box id="banner" sx={{mt:4}}>
      <Box sx={{display: {xs: 'none', sm: 'grid', md: 'grid', lg: 'grid', xl: 'grid'}, position: 'relative', p:1}}>
        <CardMedia
          component='video'
          id = 'videoIntro'
          image={"https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/landing-campos-golf.mp4"}
          autoPlay
          loop
          muted
          ref={videoRef}
          sx={{
            height: "50vh",      
            objectFit: "cover",
          }}
        >
        </CardMedia>
        <Box sx={{
          position: 'absolute',
          top: 0,
          height: 910,
          left: 0,
          width: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.30)',
          color: 'white',
          padding: '10px',
          direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"
          }}
        >
          <Box sx={{height: 600, direction:"column", justifyContent:"center", alignItems:"center", display: "flex"}}>
            <Box sx={{width: '100%'}}>
              <Typography sx={{fontFamily: fontBrand.principal,fontSize: {xl: "3", lg: "3vw", md: "3vw", sm:"3vw", xs:"3vw"}}}>
                Sé parte del club de golf más grande del mundo
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* pantalla chica */}

      <Box sx={{display: {xs: 'grid', sm: 'none', md: 'none', lg: 'none', xl: 'none'}, mt:4, position: 'relative', p:1}}>
        <CardMedia
            component='video'
            id = 'videoIntro'
            image={"https://club-vip-media.s3.us-east-1.amazonaws.com/landing-page/landing-campos-golf.mp4"}
            autoPlay
            loop
            muted
            ref={videoRef}
            sx={{
              height: "50vh",      
              objectFit: "cover",
            }}
          >
        </CardMedia>
        <Box sx={{
          position: 'absolute',
          top: 0,
          height: 550,
          left: 0,
          width: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.30)',
          color: 'white',
          padding: '10px',
          direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"
          }}
        >
          <Box sx={{height: 400, direction:"column", justifyContent:"center", alignItems:"center", display: "flex"}}>
            <Box sx={{width: '100%'}}>
              <Typography sx={{fontFamily: fontBrand.principal,fontSize: '3.8vh'}}>
                Sé parte del club de golf más grande del mundo
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
